<script setup>
</script>
<template>
  <section class="xl:py-12 lg:py-8 py-4">
    <div class="relative w-full h-full py-20 xl:py-60 lg:py-48 md:py-24 sm:py-24">
        <VLazyImage src="/assets/images/nac-banner.webp" alt="guinness world record"  class="bg-no-repeat bg-cover bg-center absolute inset-0 w-full h-full" />
    </div>
    </section>
</template>
<style scoped>
</style>
